 /*=========================================================================================
  File Name: getters.js
  Description: Menus Getters
  ----------------------------------------------------------------------------------------
  Item Name: Menu State Module
  Author: Tan Tran
==========================================================================================*/

export default {
    menuById : state => id => {
        return state.menus.find(m => m.menuId === id);
    },

    itemsNotInMenuById : state => id => {

        let menu = state.menus.find(m => m.menuId === id);
        let itemsNotInMenu = [];
        if ( menu != null) {
            let difference= state.itemsInRepository.filter( item1 => {
                return !menu.menuItems.some(item2 => {
                    return item1.itemId === item2.itemId
                })
            });
           
            itemsNotInMenu = difference;
        }
        else {
            state.itemsInRepository.forEach(o => {
                itemsNotInMenu.push(o);
            });
        }

        return itemsNotInMenu;
    },

    categoriesInRepository : state => {
        
        let key='categoryId';
        let newSet = [...new Map(state.itemsInRepository.map(item => [item[key],item])).values()];

        let categories = [];

        newSet.forEach(i => {
            //console.log(i)
            let category = {
                categoryId : i.categoryId,
                categoryName : i.category
            }
            categories.push(category);
        })
        return categories;
    }

   
}